<div>
  <div class="content">
    <div class="row">
      <div class="col-lg-4">
        <h4><b>Suivi</b></h4>
      </div>
    </div>
    <ul
      ngbNav
      class="nav-tabs mt-2"
      #nav="ngbNav"
      (navChange)="onTabChange($event)"
      [(activeId)]="suivisService.activeTabId"
      style="min-height: unset"
    >
      <li ngbNavItem="vergers">
        <a ngbNavLink>{{ 'page.suivi.titre-inventaires-vergers' | translate }}</a>
      </li>

      <li ngbNavItem="recoltes" *hasRole="'ORGANISME'">
        <a ngbNavLink>{{ 'page.suivi.titre-recoltes' | translate }}</a>
      </li>

      <li ngbNavItem="vergersEcoresponsables">
        <a ngbNavLink>{{ 'page.suivi.titre-engagements-vergers-eco' | translate }}</a>
      </li>

      <li ngbNavItem="stocks" *hasRole="'ORGANISME'">
        <a ngbNavLink>{{ 'page.suivi.titre-stocks' | translate }}</a>
      </li>

      <li ngbNavItem="ecoulements" *hasRole="'ORGANISME'">
        <a ngbNavLink>{{ 'page.suivi.titre-ecoulements' | translate }}</a>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-3"></div>

    <router-outlet></router-outlet>
  </div>
</div>
